import React, { useEffect, useRef } from "react";
import downloadWhite from "images/downloadWhite.svg";
import { Button } from "@material-ui/core";
import Table from "./Table";
import "../../../style.css";
import SelectGstinFilter from "../SelectGstinFilter";
import SearchIcon from "@material-ui/icons/Search";
import { InputAdornment } from "@material-ui/core";
import { CustomTextField } from "containers/gstr2a2bNewEnhancement/Utility/utility";
import { useDispatch, useSelector } from "react-redux";
import { downloadExcelSupplierWise, setSearchStr } from "../../action";
import { errorToastMessage } from "utils/errorToast";

const IssueWise = (props) => {
  const dispatch = useDispatch();

  const { issueWiseTableData } = useSelector(
    (store) => store.gstr2a2bNewRecoReducer
  );
  const debounceTimeout = useRef(null);
  const handleInputChange = (event) => {
    const value = event.target.value;
    dispatch(setSearchStr(value));
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      props.handleSubmit(false, value);
    }, 500);
  };
  useEffect(() => {
    return () => {
      clearTimeout(debounceTimeout.current);
      dispatch(setSearchStr(""));
    };
  }, []);

  const handleDownload = () => {
    if (!issueWiseTableData || issueWiseTableData.length === 0) {
      errorToastMessage("No data available to download");
      return;
    }
    dispatch(downloadExcelSupplierWise(issueWiseTableData, "IssueWise"));
  };
   useEffect(()=>{
    props.handleSubmit(false)
   },[])
  return (
    <>
      <div style={{ display: "flex", justifyContent: "flex-start" }}>
        <SelectGstinFilter handleSubmit={props.handleSubmit}/>
        {/* <div style={{ width: "35%", marginLeft: "1em", marginTop: "1em" }}>
          <CustomTextField
            style={{ backgroundColor: "white" }}
            placeholder="Search"
            className="custom-search-field"
            variant="outlined"
            size="small"
            onChange={handleInputChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </div> */}
        <Button
          onClick={handleDownload}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            marginTop: "1.6em",
            marginLeft: "1em",
            height: "32px",
            fontSize: "12px",
            textTransform: "capitalize",
          }}
        >
          <img
            src={downloadWhite}
            alt="Download"
            style={{
              width: "30px",
              height: "20px",
              paddingBottom: "3px",
            }}
          />
        </Button>
      </div>
      <Table />
    </>
  );
};

export default IssueWise;
